// extracted by mini-css-extract-plugin
module.exports = {"bold":"desc_bold__1cNqQ","gray":"desc_gray__2AHvr","icon":"desc_icon__2lcev","img":"desc_img__1g9Ny"};